const STORE_API_BASE_URL =
  window.__NUXT__.config?.public?.API_BASE_URL?.replace("v1", "store");

export const getStoreApiUrl = (endPoint) => {
  return `${STORE_API_BASE_URL}${endPoint}`;
};
